import { HeaderConfigItem } from '../../@types/HeaderConfig';

const config: { main: HeaderConfigItem[], connected: HeaderConfigItem[] } = {
  main: [],
  connected: [],
};

export default config;
